var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "peppol-endpoint-input" },
    [
      _c("w-select", {
        staticClass: "mrs",
        style: { minWidth: "180px", flexShrink: 0 },
        attrs: { items: _vm.schemeItems, label: _vm.$ct("schema"), fancy: "" },
        on: { input: _vm.onSchemeChange },
        model: {
          value: _vm.selectedScheme,
          callback: function ($$v) {
            _vm.selectedScheme = $$v
          },
          expression: "selectedScheme",
        },
      }),
      _c("w-input", {
        style: { flexGrow: 1 },
        attrs: { label: _vm.$ct("nummer"), fancy: "" },
        on: {
          input: _vm.onNumberChange,
          paste: _vm.onPaste,
          blur: _vm.onNumberBlur,
        },
        model: {
          value: _vm.endpointNumber,
          callback: function ($$v) {
            _vm.endpointNumber = $$v
          },
          expression: "endpointNumber",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }